"use client"
import { useState } from "react"
import dynamic from "next/dynamic"
import { ClipboardList } from "lucide-react"
import { Button } from "@/components/ui/animated/button/button"
const IntakeDrawer = dynamic(
  () => import("./drawer").then((module) => module.IntakeDrawer),
  { loading: () => null }
)
export function ConversationIntakeButton({
  threadId,
  actor,
  staff
}: {
  threadId: string
  actor: string
  staff: boolean
}) {
  const [open, setOpen] = useState(false),
    [loaded, setLoaded] = useState(false)
  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        title="Request details"
        aria-label="Request details"
        onClick={() => {
          setLoaded(true)
          setOpen(true)
        }}
      >
        <ClipboardList size={16} />
      </Button>
      {loaded && (
        <IntakeDrawer
          key={threadId}
          threadId={threadId}
          actor={actor}
          staff={staff}
          open={open}
          onOpenChange={setOpen}
        />
      )}
    </>
  )
}
